import TitleLabel from "../../../../common/Labels/TitleLabel";
import style from "./LunartCampaignAbout.module.scss";

export default function LunartCampaignAbout() {
    return (
        <div className={style.container}>
            <div className={style.title}>
                <TitleLabel
                    fontWeight={"light"}
                    text={"About"}
                    size={20}
                    color={"#fff"}
                />
            </div>
            <div className={style.contents}>
                <a
                    className={style.home}
                    href="https://www.lunart.io/"
                    target="_blank"
                />
                <a
                    className={style.twitter}
                    href="https://twitter.com/LunArt_NFT"
                    target="_blank"
                />
                <a
                    className={style.discord}
                    href="https://discord.com/invite/LunArt"
                    target="_blank"
                />
                <a
                    className={style.telegram}
                    href="https://t.me/+hD9sV3CONAFlNTll"
                    target="_blank"
                />
                <a
                    className={style.mail}
                    href="https://lunartnft.medium.com/lunart-community-driven-nft-protocol-artist-launchpad-114b94008df5"
                    target="_blank"
                />
            </div>
        </div>
    );
}
